module.exports = __webpack_public_path__ + "static/media/about-img-5.f87d444f.jpg";